export const appConfig = {
    appSlug: 'door-planner',
    appName: 'Door Planner',
    plannerTitle: 'Barrier & Security Door Planner',
    defaultBrand: 'protector',
    referencePrefix: 'DOOR',
    estate: 'pag',
    features: {
        bunnings: true,
    },
    initialised: true,
};
//# sourceMappingURL=app.js.map